import {
    CREATE_WORKFLOW_ROUTE_REQUEST,
    CREATE_WORKFLOW_ROUTE_SUCCESS,
    CREATE_WORKFLOW_ROUTE_FAILURE,
    FETCH_WORKFLOW_ROUTES_REQUEST,
    FETCH_WORKFLOW_ROUTES_SUCCESS,
    FETCH_WORKFLOW_ROUTES_FAILURE,
    UPDATE_WORKFLOW_ROUTES_REQUEST,
    UPDATE_WORKFLOW_ROUTES_SUCCESS,
    UPDATE_WORKFLOW_ROUTES_FAILURE,
    ADD_WORKFLOW_ROUTE_PERMISSIONS_REQUEST,
    ADD_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS,
    ADD_WORKFLOW_ROUTE_PERMISSIONS_FAILURE,
    FETCH_WORKFLOW_ROUTE_PERMISSIONS_REQUEST,
    FETCH_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS,
    FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE,
    REMOVE_WORKFLOW_ROUTE_PERMISSIONS_REQUEST,
    REMOVE_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS,
    REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE,
    // Add the new action types for actors
    FETCH_WORKFLOW_ROUTE_ACTORS_REQUEST,
    FETCH_WORKFLOW_ROUTE_ACTORS_SUCCESS,
    FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE,
} from "../actions/workflowRouteActionTypes";

// Define the initial state for the reducer
const initialState = {
    workflowRoutes: [],
    workflowRoutePermissions: [],
    workflowRouteActors: [], // Add this new property for actors
    loading: false,
    error: null,
};

// Define and export the reducer
const workflowRouteReducer = (state = initialState, action) => {
    switch (action.type) {
        // Handle workflow route creation request
        case CREATE_WORKFLOW_ROUTE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        // Handle successful creation of workflow routes
        case CREATE_WORKFLOW_ROUTE_SUCCESS:
            return {
                ...state,
                workflowRoutes: [...state.workflowRoutes, ...action.payload], // Append new routes to the state
                loading: false,
                error: null,
            };

        // Handle failure to create workflow routes
        case CREATE_WORKFLOW_ROUTE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // Handle workflow route fetch request
        case FETCH_WORKFLOW_ROUTES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        // Handle successful fetching of workflow routes
        case FETCH_WORKFLOW_ROUTES_SUCCESS:
            return {
                ...state,
                workflowRoutes: action.payload.map(route => ({
                    id: route.id,
                    sequence: route.sequence,
                    roleName: route.roleName,
                    roleId: route.roleId
                })),
                loading: false,
                error: null,
            };

        // Handle failure to fetch workflow routes
        case FETCH_WORKFLOW_ROUTES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // Handle workflow route update request
        case UPDATE_WORKFLOW_ROUTES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        // Handle successful updating of workflow route
        case UPDATE_WORKFLOW_ROUTES_SUCCESS:
            return {
                ...state,
                workflowRoutes: action.payload,
                loading: false,
                error: null,
            };

        // Handle successful updating of workflow route
        case UPDATE_WORKFLOW_ROUTES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case ADD_WORKFLOW_ROUTE_PERMISSIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case ADD_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS:
            return {
                ...state,
                workflowRoutePermissions: [...state.workflowRoutePermissions, ...action.payload],
                loading: false,
                error: null,
            };

        case ADD_WORKFLOW_ROUTE_PERMISSIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case FETCH_WORKFLOW_ROUTE_PERMISSIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS:
            return {
                ...state,
                workflowRoutePermissions: action.payload,
                loading: false,
                error: null,
            };

        case FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case REMOVE_WORKFLOW_ROUTE_PERMISSIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case REMOVE_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS:
            return {
                ...state,
                workflowRoutePermissions: state.workflowRoutePermissions.filter(
                    workflowRoutePermission => workflowRoutePermission.id !== action.payload
                ),
                loading: false,
                error: null,
            };

        case REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // Add the new cases for workflow route actors
        case FETCH_WORKFLOW_ROUTE_ACTORS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_WORKFLOW_ROUTE_ACTORS_SUCCESS:
            return {
                ...state,
                workflowRouteActors: action.payload, // Store the actors data
                loading: false,
                error: null,
            };

        case FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // Default case for unhandled actions
        default:
            return state;
    }
};

export default workflowRouteReducer;
